import { ProductsResponseOut } from '../../store/api';
import { localContentPrefix, shopPrefix } from '../../config';
import { AgeCategory } from '../../../models/AgeCategory';
import { mapProductOutToProductMetaDataArray } from '../ProductOutMappings';
import { ProductMetaData } from '../../../models/Product';
import { http } from '../axios';

const FETCH_PRODUCT_GROUP_PRODUCTS_URL = `${shopPrefix}/v1/productgroups/:productGroupId`;
const FETCH_LIBX_PRODUCT_GROUP_PRODUCTS_URL = `${localContentPrefix}/v1/localcontent/productgroups/:productGroupId/products`;

export type FetchProductGroupProductsApiResponse = {
    readonly total: number;
    readonly products: ReadonlyArray<ProductMetaData>;
};

export type FetchProductGroupProductsParams = {
    readonly ageCategory?: AgeCategory;
    readonly loanFormat?: string | null;
    readonly shopLanguage: string | undefined;
};

export const fetchProductGroupProducts = (
    productGroupId: string,
    { ageCategory, loanFormat, shopLanguage }: FetchProductGroupProductsParams
): Promise<FetchProductGroupProductsApiResponse> => {
    return http
        .get<ProductsResponseOut>(FETCH_PRODUCT_GROUP_PRODUCTS_URL, {
            pathParams: { productGroupId },
            params: {
                ageCategory,
                loanFormat,
                shopLanguage
            }
        })
        .then(response => ({
            total: response.data.totalHits ?? 0,
            products: mapProductOutToProductMetaDataArray(response.data.hits)
        }));
};

export const fetchLibxProductGroupProducts = (
    productGroupId: string,
    { ageCategory, shopLanguage }: FetchProductGroupProductsParams
): Promise<FetchProductGroupProductsApiResponse> => {
    return http
        .get<ProductsResponseOut>(FETCH_LIBX_PRODUCT_GROUP_PRODUCTS_URL, {
            pathParams: { productGroupId },
            params: {
                ageCategory,
                shopLanguage
            }
        })
        .then(response => ({
            total: response.data.totalHits ?? 0,
            products: mapProductOutToProductMetaDataArray(response.data.hits)
        }));
};
